/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { AbilityModel } from '../../../models/AbilityModel'
import { revertPriceNumner } from '../../../selectors'
import { useIntl } from 'react-intl'
import { ABILITIES_PAYMENT_METHOD } from '../../../constants/common'
import { NumericFormat } from 'react-number-format'
import { PayrollPaymentModel } from '../../../models/account-books/PayrollAccount'

type Props = {
    show: boolean
    mode: string
    data?: PayrollPaymentModel
    onClose: () => void
    onSubmit: (values: any, actions: any) => void
    month: string
}
const addSchema = Yup.object().shape({
    payment_method: Yup.string().nullable().required('Vui lòng chọn phương thức thanh toán'),
    salary: Yup.string().required('Vui lòng nhập số tiền')
})

const PayrollPaymentModal: React.FC<Props> = ({ show, mode, data, onClose, onSubmit, month }) => {
    const intl = useIntl();
    let initValues: any = {
        salary: data?.salary ?? 0,
        social_insurance: data?.social_insurance ?? 0,
        health_insurance: data?.health_insurance ?? 0,
        unemployment_insurance: data?.unemployment_insurance ?? 0,
        expense_group: 'payroll',
        payment_method: 'banking',
        note: 'Thanh toán lương ' + month ,
    };
    
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Tạo phiếu chi lương tháng {month}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik validationSchema={addSchema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Tiền lương</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='salary'
                                        value={values?.salary ?? 0}
                                        required
                                        className='form-control form-control-sm'
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'salary', value: revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    
                                    <ErrorMessage className='text-danger' component='span' name='salary' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">BHXH</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='social_insurance'
                                        value={values?.social_insurance ?? 0}
                                        required
                                        className='form-control form-control-sm'
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'social_insurance', value: revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    
                                    <ErrorMessage className='text-danger' component='span' name='social_insurance' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">BHYT</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='health_insurance'
                                        value={values?.health_insurance ?? 0}
                                        required
                                        className='form-control form-control-sm'
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'health_insurance', value: revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    
                                    <ErrorMessage className='text-danger' component='span' name='health_insurance' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">BHTN</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='unemployment_insurance'
                                        value={values?.unemployment_insurance ?? 0}
                                        required
                                        className='form-control form-control-sm'
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'unemployment_insurance', value: revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    
                                    <ErrorMessage className='text-danger' component='span' name='unemployment_insurance' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Phương thức thanh toán</label>
                                    <Field
                                            as='select'
                                            name='payment_method'
                                            className='form-select'
                                    >
                                        <option value=""></option>
                                        {ABILITIES_PAYMENT_METHOD.map((method: any) => (
                                            <option key={method.id} value={method.id}>{method.label}</option>
                                        ))}
                                    </Field>
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Ghi chú</label>
                                    <Field
                                        as="textarea"
                                        className="form-control"
                                        value={values.note ?? ""}
                                        id="note"
                                        name="note"
                                        rows={3}
                                    />
                                    <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='note' /></div>
                                </div>
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Hủy</button>
                                <button className="btn btn-bg-success" type="submit">Thêm</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default PayrollPaymentModal
